<template>
  <div class="PageBox">
    <div class="ScrollBox">
      <div class="RechargeInfo" v-if="rechargeId">
		<van-cell :title="$t('recharge.info[0]')">
		  <template>
		    {{InitData.currency}}<em>{{Number(rechargeData.money||0).toLocaleString()}}</em>
		  </template>
		</van-cell>
		<van-field 
		  readonly 
		  :label="$t('recharge.info[1]')" 
		  :value="rechargeData.orderNumber"
		>
		  <template #button>
		    <span id="IosOrder" style="position: absolute;opacity: 0">{{rechargeData.orderNumber}}</span>
		    <input id="AppOrder" type="text" readonly :value="rechargeData.orderNumber" style="position: absolute;opacity: 0">
		    <van-button size="mini" type="primary" @click="$Util.CopyText('IosOrder','AppOrder')">{{$t('recharge.info[5]')}}</van-button>
		  </template>
		</van-field>
		<van-field 
		  readonly 
		  :label="$t('recharge.info[11]')" 
		  :value="rechargeData.remarks"
		  v-if="rechargeData.remarks"
		/>
		<van-divider :hairline="false" style="text-align: center;margin: 10px 0" v-if="rechargeData&&rechargeData.receive.length"><span v-html="$t('recharge.tips[0]')"></span></van-divider>
		<van-divider :hairline="false" style="text-align: center;margin: 10px 0" v-else><span v-html="$t('recharge.tips[5]')"></span></van-divider>
      </div>
      <div v-else>
        <div v-if="!showPrice">
          <van-divider content-position="left">
            <i18n path="recharge.default[3]">
              <em style="color:#4087f1" slot="money">{{InitData.currency}}{{Number(UserInfo.balance).toLocaleString()}}</em>
            </i18n>
          </van-divider>
          <van-cell-group class="RechargeList" :border="false" v-if="rechargeList">
            <van-cell v-for="item in rechargeList" :key="item.type" is-link @click="selectType(item.type)">
              <template #icon>
                <img :src="`./static/icon/digital.png`" height="40" style="border-radius: 100%;margin-right: 10px">
              </template>
              <template #title>
                <b>{{item.code}}</b>
              </template>
              <template #label>
                {{$t('recharge.default[9]',{currency:InitData.currency,min:item.minPrice,max:item.maxPrice,fee:item.fee})}}
              </template>
            </van-cell>
          </van-cell-group>
        </div>
        <div class="mt15" v-else> 	
			<van-field
			:border="false" 
			readonly 
			:value="rechargeInfo.name" 
			label="">
			<template #button>
			  <span :id="`IosName`" style="position: absolute;opacity: 0">{{rechargeInfo.name}}</span>
			  <input :id="`AppName`" type="text" readonly :value="rechargeInfo.name" style="position: absolute;opacity: 0">
			  <van-button size="mini" type="primary" @click="$Util.CopyText(`IosName`,`AppName`)">{{$t('recharge.info[5]')}}</van-button>
			</template>
			</van-field>
			<van-field 
			:border="false" 
			readonly 
			:value="rechargeInfo.account" 
			label="">
			<template #button>
			  <span :id="`IosAccount`" style="position: absolute;opacity: 0">{{rechargeInfo.account}}</span>
			  <input :id="`AppAccount`" readonly :value="rechargeInfo.account" style="position: absolute;opacity: 0">
			  <van-button size="mini" type="primary" @click="$Util.CopyText(`IosAccount`,`AppAccount`)">{{$t('recharge.info[5]')}}</van-button>
			</template>
			</van-field>
			<van-field
			  class="MoneyList" 
			  :label="$t('recharge.label[0]')" 
			  size="large"
			  label-width="80"
			  v-if="rechargeInfo.fixed"
			>
			  <template #input>
			    <van-radio-group v-model="postData.money" direction="horizontal">
			      <van-radio :name="item" v-for="item in rechargeInfo.fixed.split(',')" :key="item">{{item}}</van-radio>
			    </van-radio-group>
			  </template>
			</van-field>
			<van-field 
			  v-model.trim="postData.money"
			  type="number"
			  :label="$t('recharge.label[0]')" 
			  :placeholder="$t('recharge.placeholder[0]')" 
			  size="large"
			  label-width="80"
			   @input="inputMoney"
			   style="color:#333"
			/>
			<div style="position: absolute;z-index: 1;right: 1rem;margin-top: -2.26rem;color: #333;">({{all.toFixed(2)}}{{InitData.currency}})</div>
			<!-- <van-field 
			  v-model.trim="postData.name"
			  type="text"
			  :label="$t('recharge.label[7]')" 
			  :placeholder="$t('recharge.placeholder[10]')" 
			  size="large"
			  label-width="80"
			/> -->
			<div class="zhpz">
				<label >{{$t('recharge.info[7]')}}</label>
				<van-uploader v-model="fileList" :after-read="afterRead" multiple />
			</div>
			
		  <van-divider :hairline="false" style="text-align: center;margin: 10px 0"><span v-html="$t('recharge.tips[5]')"></span></van-divider>
		  <van-divider :hairline="false">{{$t('recharge.tips[6]')}}</van-divider>
		  <van-divider :hairline="false">{{$t('recharge.tips[4]')}}</van-divider>
          <div style="padding: 20px 15px;">
            <van-button block type="danger" :loading="isSubmit" :loading-text="$t('recharge.default[5]')" style="font-size: 18px;" @click="onSubmit">{{$t('recharge.default[6]')}}</van-button>
            <van-button block style="font-size: 18px;margin-top: 10px;" @click="showPrice=false">{{$t('recharge.default[7]')}}</van-button>
          </div>
        </div>
      </div>
      <van-loading class="Loading" size="50" vertical v-if="isLoad">{{$t('recharge.default[8]')}}</van-loading>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Digital',
  components: {

  },
  props: ['rechargeId'],
  data() {
    return {
      amountMoney: this.$route.query.amount||'',
      postData: {
        money: this.$route.query.amount||'',
        recharge_id: '',
        name: ''
      },
      rechargeList: '',
      pickerList: '',
      showPicker: false,
      isSubmit: false,
      rechargeData: '',
      rechargeInfo: '',
      showPrice: false,
      pickerName: '',
      isLoad: true,
      fileList: [],
	  all:0,
    }
  },
  computed: {

  },
  watch: {
    $route(){
      if(this.rechargeId){
        this.$parent.navBarTitle = this.$t('recharge.default[1]')
        this.getRechargeInfo()
      }else{
        this.$parent.navBarTitle = this.$t('wallet.default[7]')
        this.$Model.GetDigital(data=>{
          this.isLoad = false
          this.rechargeList = data
        })
      }
    },
  },
  created() {
    if(this.rechargeId){
      this.$parent.navBarTitle = this.$t('recharge.default[1]')
      this.getRechargeInfo()
    }else{
      this.$parent.navBarTitle = this.$t('wallet.default[7]')
      this.$Model.GetDigital(data=>{
        this.isLoad = false
        this.rechargeList = data
      })
    }
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
	  inputMoney(value) {
	  	this.all = value * this.rechargeInfo.exchange_rate;
	  },
    selectType(typeid) {
      this.postData = {
        money: this.$route.query.amount||'',
        recharge_id: typeid,
        name: ''
      }

      this.rechargeInfo = this.rechargeList.find(item=>item.type==typeid)
	  //console.log(this.rechargeInfo);
      this.showPrice = true
      if(this.rechargeInfo.bankList){
        this.pickerList = this.rechargeInfo.bankList
      }else{
        this.pickerList = ''
      }
    },
    onSubmit() {
      if(!this.postData.money){
        this.$Dialog.Toast(this.$t('recharge.placeholder[0]'));
        return;
      }
      if(Number(this.postData.money)<Number(this.rechargeInfo.minPrice)){
        this.$Dialog.Toast(this.$t('recharge.placeholder[3]',{currency: this.InitData.currency,min:this.rechargeInfo.minPrice}));
        return;
      }
      if(Number(this.postData.money)>Number(this.rechargeInfo.maxPrice)){
        this.$Dialog.Toast(this.$t('recharge.placeholder[4]',{currency: this.InitData.currency,max:this.rechargeInfo.maxPrice}));
        return;
      }
	  /* if(!this.postData.name){
		this.$Dialog.Toast(this.$t('recharge.placeholder[2]'));
		return;
	  } */
	  if(!this.fileList.length){
		  this.$Dialog.Toast(this.$t('recharge.placeholder[9]'));
		  return;
	   }
	  this.isSubmit = true;
	  const picUrls = this.fileList.flatMap(item=>item.url)

	  this.$Model.RechargeOrder({money:this.postData.money,name:this.postData.name,recharge_id:this.postData.recharge_id,pic_url:picUrls},data=>{
		this.isSubmit = false;
		if(data.code==1){
		  this.showPrice = false;
		  this.rechargeData = data
		}
	  })
      
    },
    afterRead(file) {
      file.status = 'uploading'
      file.message = this.$t('upload[0]')
      this.uploadImgs(file)
    },
    compressImg(file) {
      this.$Util.CompressImg(file.file.type,file.content,750,(image)=>{
        let param = new FormData();
        param.append('token',localStorage['Token']);
        param.append('type',4);
        param.append('image',image,file.file.name);
        this.$Model.UploadImg(param,(data)=>{
          if(data.code==1){
            file.message = this.$t('upload[2]')
            file.status = 'success'
            file.url = data.url
          }else{
            file.status = 'failed'
            file.message = this.$t('upload[3]')
          }
        });
      })
    },
    uploadImgs(file){
      if(file.length){
        file.forEach(item=>{
          if (!item.file.type.match(/image/)){
            item.status = 'failed'
            item.message = this.$t('upload[1]')
            return;
          }
          this.compressImg(item)
        })
      }else{
        if (!file.file.type.match(/image/)){
          file.status = 'failed'
          file.message = this.$t('upload[1]')
          return;
        }
        this.compressImg(file)
      }
    },
    setOrderInfo() {
      const screenshots = this.fileList.flatMap(item=>item.url.replace(this.InitData.setting.up_url,''))
      this.$Model.SetOrderInfo({orderNumber: this.rechargeId,screenshots: screenshots},data=>{
        this.getRechargeInfo()
      })
    },
    getRechargeInfo() {
      this.$Model.GetRechargeInfo(this.rechargeId,data=>{
        this.isLoad = false
        this.rechargeData = data
        this.fileList = data.screenshots?data.screenshots.flatMap(item=>[{url: this.InitData.setting.up_url+item}]):[]
      })
    },
  }
}
</script>
<style scoped>
.ScrollBox .van-cell>>>.van-field__button{padding: 0;}
.RechargeList{
  margin-bottom: 20px;
}
.RechargeList .van-cell__title{
  line-height: 1;
}
.RechargeInfo .van-cell>>>.van-field__control{
  text-align: right;
}
.RechargeInfo .van-cell--large>>>.van-field__control{
  font-size:16px;
}
.RechargeInfo .van-cell .van-cell__value em{
  font-size: 20px;
  color: #4087f1;
}
.RechargeInfo .van-panel{
  margin: 10px;
  border: 1px rgba(255, 255,255,.2) solid;
  border-radius: 3px;
  background-color: #151d31;
}
.RechargeInfo .van-panel__header{
  background-color: #242d41;
  color: #fff;
}
.RechargeInfo .van-panel__content .van-cell{
  padding: 0 16px;
  margin: 10px 0;
}
.RechargeInfo .van-panel__content>>>.van-field__control{
  text-align: left;
}
.RechargeInfo .van-panel__content img{
  width: 80%;
  margin: 0 auto;
  display: block;
}
.van-divider{
  font-size: 12px;
  line-height: 1.5;
}
.MoneyList{
  word-break: break-word;
}
.MoneyList .van-cell__value{
  flex: auto;
}
.MoneyList .van-radio--horizontal{
  margin: 3px 6px 3px 0;
  position: relative;
}
.MoneyList .van-radio-group>>>.van-radio__icon{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.MoneyList .van-radio-group>>>.van-radio__icon--checked~.van-radio__label{
  padding: 0 17px 0 3px;
}
.MoneyList .van-radio-group>>>.van-radio__icon .van-icon{
  width: 100%;
  border-radius: 5px;
  text-align: right;
  font-size: 14px;
  height: 28px;
  line-height: 28px;
}
.MoneyList .van-radio-group>>>.van-radio__label{
  margin: 0;
  position: relative;
  z-index: 9;
  padding: 0 10px;
  line-height: 28px;
  color:#fff;
}
.van-uploader>>>.van-uploader__upload,.van-uploader>>>.van-uploader__preview-image{
  width: 60px;
  height: 60px;
}
.van-uploader>>>.van-uploader__upload,.van-uploader>>>.van-uploader__preview{
  margin: 4px 8px 4px 0;
  background-color: #f7f8fa;
  border-radius: 8px;
}
.zhpz{display: flex;align-items: center;overflow: hidden;margin: 13px 0;}
.zhpz label{color:#333;position: relative;display: flex;box-sizing: border-box;padding: 10px 16px;overflow: hidden;font-size: 14px;}
</style>